<template>
	<div class="shadowed">
		<div class="inner-content-title">
			Parâmetros da roterização
		</div>
		<div class="router-loading" v-if="loading">
			<i class="fa fa-circle-notch fa-spin"></i>
		</div>
		<div class="router-container" v-if="!loading">
			<div class="row">
				<div class="col-xs-12">
					<div class="row">
						<div v-if="client_atak" class="col-xs-12 col-lg-3">
							<FormSelect v-model="settings.integration" label="Integração" icon="fa-external-link-alt" :options="options.integrations" tooltip="Informe a integração utlizada por sua empresa" />
						</div>
						<div v-if="client_atak" class="col-xs-12 col-lg-9">
							<FormInput v-model="settings.url_api_atak" label="URL da API do sistema integrado (ex.: https://www.webapiatak.com.br/api)" type="url" icon="fa-external-link-alt" tooltip="Informe o link de acesso a API do sistema integrado (essa informação é necessária para o processo de sincronização dos pedidos e clientes com o sistema integrado)" />
						</div>
						<div class="col-xs-12 col-lg-3">
							<FormInput type="time" class="timepicker" v-model="settings.start_time" label="Horário inicial" icon="fa-business-time" aria-placeholder="" ref="start_time" tooltip="Informe o horário padrão estimado para o início do roteiro"  />
						</div>
						<div class="col-xs-12 col-lg-3">
							<FormInput type="time" v-model="settings.end_time" label="Horário final" icon="fa-business-time" ref="end_time" tooltip="Informe o horário padrão estimado para o término do roteiro" />
						</div>
						<div class="col-xs-12 col-lg-3">
							<FormInput v-model="settings.start_lunch_time" label="Horário inicial do almoço" icon="fa-utensils" type="time" ref="start_lunch_time" tooltip="Informe o horário padrão estimado para o início de intervalo ou almoço no roteiro" />
						</div>
						<div class="col-xs-12 col-lg-3">
							<FormInput v-model="settings.end_lunch_time" label="Horário final do almoço" icon="fa-utensils" type="time" ref="end_lunch_time" tooltip="Informe o horário padrão estimado para o término de intervalo ou almoço no roteiro" />
						</div>
						<div class="col-xs-12 col-lg-3">
							<FormInputMasked type="tel" v-model="settings.average_speed" label="Velocidade Média" icon="fa-tachometer-alt" :mask="['# km/h','## km/h','### km/h']" ref="average_speed" tooltip="Informe a velocidade média padrão em trânsito dos veículos do roteiro"  />
						</div>
						<div class="col-xs-12 col-lg-3">
							<FormInputMasked type="tel" v-model="settings.discharge_weight_per_minut" label="Descarregamento de peso por minuto" icon="fa-people-carry" :mask="['# kg/min','## kg/min','### kg/min','#### kg/min','##### kg/min','###### kg/min','####### kg/min','######## kg/min','######### kg/min']" ref="discharge_weight_per_minut"  tooltip="Informe o tempo médio padrão de descarregamento do peso por minuto" />
						</div>
						<div class="col-xs-12 col-lg-3">
							<FormInputMasked type="tel" v-model="settings.average_discharge_time" label="Tempo médio de descarregamento" icon="fa-people-carry" :mask="['# min','## min','### min','#### min','##### min']" ref="average_discharge_time" tooltip="Informe o tempo médio padrão de descarregamento em cada cliente" />
						</div>
						<div class="col-xs-12 col-lg-3">
							<FormSelect v-model="settings.show_delivery_type" :options="options.types" label="Tipo de entregas exibidas" icon="fas fa-box" ref="show_delivery_type" tooltip="Selecione o tipo padrão das entregas que serão exibidas para roteização" />
						</div>
						<div class="col-xs-12 col-lg-3">
							<FormSelect v-model="settings.export_separator" :options="options.separators" label="Separador do arquivo CSV" icon="fas fa-file-csv" ref="export_separator" tooltip="Selecione o separador padrão no arquivo de exportação do roteiro .csv" />
						</div>
						<div v-if="client_atak" class="col-xs-12 col-lg-3">
							<FormSelect v-model="settings.generate_cargo" :options="options.generate_cargo" label="Gerar código da carga automático" icon="fas fa-boxes" ref="generate_cargo" tooltip="Informe se deseja gerar o código da carga automaticamente ao finalizar um roteiro" />
						</div>
						<div v-if="client_atak" class="col-xs-12 col-lg-3">
							<FormInput v-model="settings.default_driver_code" label="Código do motorista padrão" icon="fas fa-address-card" type="tel" tooltip="Informe o ID no sistema integrado ou CPF do motorista padrão para a sincronização da carga de um roteiro (esta informação será enviada ao sistema integrado quando não for especificado um motorista para a carga do veículo)" ref="default_driver_code" />
						</div>
						<div v-if="client_atak" class="col-xs-12 col-lg-3">
							<FormInput v-model="settings.default_shipping_company_code" label="Código da transportadora padrão" icon="fas fa-warehouse" type="tel" tooltip="Informe o ID no sistema integrado ou CNPJ da transportadora padrão para a sincronização da carga de um roteiro (esta informação será enviada ao sistema integrado)" ref="default_shipping_company_code" />
						</div>
						<div v-if="client_atak" class="col-xs-12 col-lg-3">
							<FormInput v-model="settings.default_moviment_type_code" label="Código do tipo de movimento" icon="fas fa-dolly" type="text" tooltip="Informe o código do tipo de movimento que será utilizado para identificar pedidos, vindos do seu sistema integrado, como pontos de paradas (essa informação será utilizada para visualizar no mapa do roteiro, os pontos de parada obrigatórios em cada rota)" ref="default_moviment_type_code" />
						</div>
						<div v-if="client_atak" class="col-xs-12 col-lg-3">
							<FormSelect v-model="settings.default_customer_sync_name" :options="options.default_customer_sync_name" label="Nome padrão do cliente" icon="fas fa-building" tooltip="Informe nome padrão que deve ser armazenado para os registros de cliente sincronizados com o sistema integrado" ref="default_customer_sync_name" />
						</div>
						<div class="col-xs-12 col-lg-2">
							<label for="">
								Fator de correção {{(settings.correction_fact / 100)}}
							</label>
							<FormInput type="range" v-model="settings.correction_fact" step="1" min="10" max="100" aria-placeholder="" ref="correction_fact" style="margin-top: -5px" tooltip="Informe o fator de correção padrão da precisão do roteirizador" />
						</div>
					</div>
				</div>
			</div>
			<button class="button-edit" @click="save">
				<i class="fa fa-fw fa-save"></i> SALVAR
			</button>
		</div>
	</div>
</template>

<script>
import Api from "@/lib/Api";

import FormInput from "@/components/FormInput";
import FormInputMasked from "@/components/FormInputMasked";
import FormSelect from "@/components/FormSelect";

export default {
	name: "ConfigRouting",

	components: {
		FormInput, 
		FormInputMasked, 
		FormSelect,
	},

	data: function() {
		return {
			loading: true,
			original: {},
			settings: {},
			options: {
				integrations: {
					"atak": "SISTEMA ATAK",
				},
				types: {
					"0": "Nota Fiscal",
					"1": "Pedido",
					"A": "Todos",
				},
				separators: {
					",": "Vírgula: ,",
					";": "Ponto e Vírgula: ;",
				},
				generate_cargo: {
					"0": "Não",
					"1": "Sim",
				},
				default_customer_sync_name: {
					"R": "Razão Social",
					"N": "Nome Fantasia",
				},
			},
			client_atak: this.$api.user.company_client_atak,
		};
	},

	computed: {
		/*diff: function() {
			for (let i in this.original) {
				if (this.settings[i] != this.original[i]) {
					return true;
				}
			}
			return false;
		}*/
	},

	mounted: function() {
		this.load();
	},

	methods: {
		load: async function() {
			this.loading = true;
			let res = await Api.post("config/load-settings");
			this.loading = false;

			if (res.error) {
				this.$notification.error(res.data);
				return;
			}
			
			this.original = Object.assign({}, res.data);
			this.settings = Object.assign({}, res.data);
			if (this.client_atak) this.settings.integration = "atak";
		},

		// Retorna messagem de erro no campo determinado
		message: function(input) {
			return "'" + input + "' deve ser preenchido.";
		},
		
		// Valida os campos
		validation: function () {
			let error = false;

			// Verifica o preenchimento dos horários
			if((this.settings.start_time != "") && (this.settings.end_time != "")) {
				if(this.settings.start_time >= this.settings.end_time) {
					this.$notification.error("Horário de inicio não pode ser maior, ou igual, ao Horário de término.");
					this.$refs.start_time.error = "Horário inválido";
					this.$refs.end_time.error = "Horário inválido";
					error = true;
				}
			} else {
				if((this.settings.start_time != "") && (this.settings.end_time == "")) {
					this.$notification.error("Horário de término não preenchido.");
					this.$refs.end_time.error = "Horário inválido";
					error = true;
				}

				if((this.settings.start_time == "") && (this.settings.end_time != "")) {
					this.$notification.error("Horário de início não preenchido.");
					this.$refs.start_time.error = "Horário inválido";
					error = true;
				}
			}
			
			// Verifica o preenchimento dos horários de almoço
			if((this.settings.start_lunch_time != "") && (this.settings.end_lunch_time != "")) {
				if(this.settings.start_lunch_time >= this.settings.end_lunch_time) {
					this.$notification.error("Horário de inicio do almoço não pode ser maior, ou igual, ao Horário de término do almoço.");
					this.$refs.start_lunch_time.error = "Horário inválido";
					this.$refs.end_lunch_time.error = "Horário inválido";
					error = true;
				}
			} else {
				if((this.settings.start_lunch_time != "") && (this.settings.end_lunch_time == "")) {
					this.$notification.error("Horário de término do almoço não preenchido.");
					this.$refs.end_lunch_time.error = "Horário inválido";
					error = true;
				}

				if((this.settings.start_lunch_time == "") && (this.settings.end_lunch_time != "")) {
					this.$notification.error("Horário de início do almoço não preenchido.");
					this.$refs.start_lunch_time.error = "Horário inválido";
					error = true;
				}
			}

			// Verifica o preenchimento dos horários
			if((this.settings.start_time != "") && (this.settings.end_time != "") && (this.settings.start_lunch_time != "") && (this.settings.end_lunch_time != "")) {
				if(this.settings.start_time >= this.settings.start_lunch_time) {
					this.$notification.error("Horário de inicio não pode ser maior, ou igual, ao Horário de início do almoço.");
					this.$refs.start_time.error = "Horário inválido";
					this.$refs.start_lunch_time.error = "Horário inválido";
					error = true;
				}

				if(this.settings.start_time >= this.settings.end_lunch_time) {
					this.$notification.error("Horário de inicio não pode ser maior, ou igual, ao Horário de término do almoço.");
					this.$refs.start_time.error = "Horário inválido";
					this.$refs.end_lunch_time.error = "Horário inválido";
					error = true;
				}

				if(this.settings.end_time <= this.settings.start_lunch_time) {
					this.$notification.error("Horário de término não pode ser menor, ou igual, ao Horário de início do almoço.");
					this.$refs.end_time.error = "Horário inválido";
					this.$refs.start_lunch_time.error = "Horário inválido";
					error = true;
				}

				if(this.settings.end_time <= this.settings.end_lunch_time) {
					this.$notification.error("Horário de término não pode ser menor, ou igual, ao Horário de término do almoço.");
					this.$refs.end_time.error = "Horário inválido";
					this.$refs.end_lunch_time.error = "Horário inválido";
					error = true;
				}
			}
			
			// Verifica a velocidade média
			if(this.settings.average_speed != "") {
				let average_speed = this.settings.average_speed.split(" ");
				if(average_speed.length == 2) {
					if(parseInt(average_speed[0]) <= 0) {
						this.$notification.error("Velocidade média não pode ser igual ou menor que zero.");
						this.$refs.average_speed.error = "Valor inválido";
						error = true;
					}
				} else {
					this.$notification.error("Velocidade inválida.");
					this.$refs.average_speed.error = "Valor inválido";
					error = true;
				}
			}
			
			// Verifica o descarregamento
			if((this.settings.discharge_weight_per_minut != "") && (this.settings.average_discharge_time != "")) {
				this.$notification.error("É necessário informar somente um dos dois campo, o Descarregamento de peso por minuto ou o Tempo médio de descarregamento.");
				this.$refs.discharge_weight_per_minut.error = "Valor inválido";
				this.$refs.average_discharge_time.error = "Valor inválido";
				error = true;
			} else {
				if(this.settings.discharge_weight_per_minut != "") {
					let discharge_weight_per_minut = this.settings.discharge_weight_per_minut.split(" ");
					if(discharge_weight_per_minut.length == 2) {
						if(parseInt(discharge_weight_per_minut[0]) <= 0) {
							this.$notification.error("Descarregamento de peso por minuto não pode ser igual ou menor que zero.");
							this.$refs.discharge_weight_per_minut.error = "Valor inválido";
							error = true;
						} else {
							this.$refs.average_discharge_time.error = "";
						}
					} else {
						this.$notification.error("Descarregamento de peso por minuto inválido.");
						this.$refs.discharge_weight_per_minut.error = "Valor inválido";
						error = true;
					}
				}
				if(this.settings.average_discharge_time != "") {
					let average_discharge_time = this.settings.average_discharge_time.split(" ");
					if(average_discharge_time.length == 2) {
						if(parseInt(average_discharge_time[0]) <= 0) {
							this.$notification.error("Tempo médio de descarregamento não pode ser igual ou menor que zero.");
							this.$refs.average_discharge_time.error = "Valor inválido";
							error = true;
						} else {
							this.$refs.discharge_weight_per_minut.error = "";
						}
					} else {
						this.$notification.error("Tempo médio de descarregamento inválido.");
						this.$refs.average_discharge_time.error = "Valor inválido";
						error = true;
					}
				}
			}

			// Verifica o separador para exportação
			if(this.settings.export_separator == "") {
				this.settings.export_separator = ",";
			}
			
			// Verifica se deve gerar o código automático
			if(this.settings.generate_cargo == "") {
				this.settings.generate_cargo = "1";
			}

			return error;
		},

		save: async function() {
			let result = this.validation();

			if(result) return;

			this.loading = true;
			let res = await Api.post("config/save-settings", {settings: this.settings});
			this.loading = false;

			if (res.error) {
				this.$notification.error(res.data);
			} else {
				this.$notification.success("Configurações salvas com sucesso.");
			}
			
			this.load();
			this.$emit("updated");
		}
	}
}
</script>

<style scoped="">
.router-loading {
	width: 100%;
	height: 250px;
	font-size: 60px;
	text-align: center;
	line-height: 250px;
	background-color: #fff;
	color: #ccc;
}

.router-container {
	width: 100%;
	background-color: #fff;
	padding: 15px;
}

.button-edit {
	padding: 10px 20px;
	font-size: 14px;
	font-weight: bold;
}

label {
	position: relative;	
	color: #666;	
	font-family: Roboto, Helvetica, Arial, sans-serif;
	font-size: 12px;
}

</style>